export const uk = {
    number: '№ {id}'
};
